"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameDiscountAndHairdresserId = exports.SameHairdresserId = exports.SameDiscount = void 0;
var range_1 = require("./range");
exports.SameDiscount = function (r1, r2) {
    return r1.discount === r2.discount;
};
exports.SameHairdresserId = function (r1, r2) {
    return r1.hairdresserId === r2.hairdresserId;
};
exports.SameDiscountAndHairdresserId = function (r1, r2) { return r1.hairdresserId === r2.hairdresserId && r1.discount === r2.discount; };
var mergeTwoRanges = function (range1, range2) {
    var newRange = {
        start: range1.start.getTime() < range2.start.getTime() ? range1.start : range2.start,
        end: range1.end.getTime() > range2.end.getTime() ? range1.end : range2.end,
    };
    return newRange;
};
var mergeRanges = function (range, ranges) {
    var newRange = ranges.reduce(function (acc, current) { return (__assign(__assign({}, acc), { range: mergeTwoRanges(acc.range, current.range) })); }, range);
    return newRange;
};
/**
 * Merge overlapping common range, comparisonFunc is there to merge only range
 * who validate comparison
 */
var Merge = function (list, comparisonFunc) {
    var listWithDate = range_1.rangesToRangesDates(list);
    var mergedList = listWithDate.reduce(function (acc, current) {
        var rangesToMerge = acc.filter(function (ranges) {
            var overlap = range_1.overlappingOrTouching(ranges.range, current.range);
            var compare = comparisonFunc(current, ranges);
            return overlap && compare;
        });
        if (!rangesToMerge) {
            return __spreadArrays(acc, [current]);
        }
        var rangeMerged = mergeRanges(current, rangesToMerge);
        return __spreadArrays(acc.filter(function (ranges) {
            return !range_1.overlappingOrTouching(ranges.range, current.range) ||
                !comparisonFunc(current, ranges);
        }), [
            rangeMerged,
        ]);
    }, []);
    return mergedList;
};
exports.default = Merge;
